export const LOADING_PLAN_SEGUIMIENTO = "LOADING_PLAN_SEGUIMIENTO";
export const SAVE_LOADING_PLAN_SEGUIMIENTO = "SAVE_LOADING_PLAN_SEGUIMIENTO";
export const GET_PLAN_SEGUIMIENTO = "GET_PLAN_SEGUIMIENTO";
export const FORM_FAIL = "FORM_FAIL";
export const PLAN_SEGUIMIENTO_FAIL = "PLAN_SEGUIMIENTO_FAIL";
